import { QueryCache, QueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { HttpError } from 'api/api-client/HttpError';
import { logger } from 'utils';

const config = {
  get: () =>
    new QueryClient({
      queryCache: new QueryCache({
        onError: (error, query) => {
          const meta = query.meta?.error;

          if (error instanceof HttpError) {
            const status = error.status;

            if (status && meta?.acceptStatus?.includes(status)) {
              return;
            }
          }

          if (meta?.notification) {
            return notification.error(meta?.notification);
          }

          if (!meta?.bypassLogger) {
            logger.log(error);
          }
        },
      }),
      defaultOptions: {
        queries: {
          staleTime: 120 * 1000, // 120 seconds
          retry: 0,
          refetchInterval: false,
          refetchOnWindowFocus: false,
        },
        mutations: {
          onError: (e: unknown, variables) => {
            logger.log(e, [{ category: 'mutation', message: JSON.stringify(variables) }]);
          },
        },
      },
    }),
};

export default config;
